// feesAPI.js

const sendFeesData = async (token, selectedSectionId, feesData) => {
    try {
        const response = await fetch(`https://test.creative-its.com/back/api/section/fees/${selectedSectionId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                token: token,
                fees: feesData
            })
        });

        if (!response.ok) {
            throw new Error('Failed to send fees data');
        }

        const data = await response.json();
        console.log(data);
        return data;
    } catch (error) {
        console.error('Error sending fees data:', error);
        throw error;
    }
};

export { sendFeesData };
